import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Eye, Clock } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const fmtDur = (s) => {
  if (s == null) return '—';
  if (s < 60) return `${s}s`;
  if (s < 3600) return `${Math.floor(s/60)}m ${s%60}s`;
  return `${Math.floor(s/3600)}h ${Math.floor((s%3600)/60)}m`;
};
const fmtDate = (s) => { try { return new Date(s).toLocaleString(); } catch { return s || '—'; } };

const RecentPreviewsCard = () => {
  const [items, setItems] = useState([]);
  useEffect(() => {
    axios.get(`${API}/admin/preview/recent?limit=15`, { withCredentials: true })
      .then((r) => setItems(r.data?.items || []))
      .catch(() => setItems([]));
  }, []);

  if (!items.length) return null;

  return (
    <div data-testid="admin-recent-previews" className="bg-[#141414] border border-[#262626] rounded-md p-5">
      <div className="flex items-center justify-between mb-3">
        <p className="text-[#D4AF37] text-[10px] font-bold tracking-[0.22em] uppercase flex items-center gap-2">
          <Eye className="w-3.5 h-3.5" /> Recent Portal Previews
        </p>
        <span className="text-[#525252] text-[10px]">{items.length} sessions</span>
      </div>
      <ul className="divide-y divide-[#262626] -my-2">
        {items.slice(0, 8).map((it, i) => (
          <li key={i} className="py-2.5 flex items-start gap-3">
            <span className={`w-1.5 h-1.5 rounded-full mt-1.5 shrink-0 ${it.active ? 'bg-emerald-400 animate-pulse' : 'bg-[#525252]'}`} />
            <div className="flex-1 min-w-0">
              <p className="text-sm">
                <span className="text-white">{it.admin_name || 'Admin'}</span>
                <span className="text-[#525252]"> viewed </span>
                <span className="text-[#D4AF37]">{it.target_name || 'user'}</span>
                <span className="text-[#525252]"> ({(it.target_role || '').replace(/_/g, ' ')})</span>
              </p>
              <p className="text-[10px] text-[#525252] uppercase tracking-wider mt-0.5 flex items-center gap-2">
                <Clock className="w-3 h-3" /> {fmtDate(it.started_at)} · duration {fmtDur(it.duration_seconds)} {it.active && <span className="text-emerald-400">· active</span>}
              </p>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default RecentPreviewsCard;
